module.exports = __webpack_public_path__ + "4f589f4867dbd57elogo.07fcebf3.png";